export default "__VITE_ASSET__DrW_nm6k__"